import { createColumnHelper } from '@tanstack/react-table'
import { useMemo } from 'react'

import {
  DataTypeColumn,
  createTableColumnHelper,
} from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { HotelAmenityFields } from 'constants/hotelAmenities'
import { usePreferences } from 'context/preferences/PreferencesContext'
import { HotelAmenitiesChips } from './HotelAmenitiesChips'

const HOTEL_AMENITIES_COLUMN_SIZE = 260

// Builds the synthetic "Hotel Amenities" chip column for both LodgingTable and
// LodgingDoorsTable so they stay in lockstep.
export function useHotelAmenitiesColumn<
  T extends { lodging?: HotelAmenityFields | null },
  C extends { hotel_amenities: DataTypeColumn },
>(columns: C) {
  const { preferences } = usePreferences()
  const tooltips: Record<string, unknown> = preferences?.tooltips || {}
  const columnHelper = useMemo(() => createColumnHelper<T>(), [])
  const lodgingColumnHelper = useMemo(
    () => createTableColumnHelper({ columns, tooltips }),
    [columns, tooltips]
  )

  return useMemo(
    () =>
      columnHelper.display({
        ...lodgingColumnHelper.retrieveColumn('hotel_amenities'),
        size: HOTEL_AMENITIES_COLUMN_SIZE,
        cell: (info) => (
          <HotelAmenitiesChips data={info.row.original.lodging} />
        ),
      }),
    [columnHelper, lodgingColumnHelper]
  )
}
